import { render, staticRenderFns } from "./ComprehensiveInformationQuery.vue?vue&type=template&id=4d889d40&scoped=true"
import script from "./ComprehensiveInformationQuery.vue?vue&type=script&lang=js"
export * from "./ComprehensiveInformationQuery.vue?vue&type=script&lang=js"
import style0 from "./ComprehensiveInformationQuery.vue?vue&type=style&index=0&id=4d889d40&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d889d40",
  null
  
)

export default component.exports